import { Routes, Route } from "react-router"
import { RequireAuth, RequireHostOwner } from "./auth/RequireAuth.js"
import { AppShell } from "./layout/AppShell.js"
import { ServerTabsLayout } from "./layout/ServerTabsLayout.js"
import { LandingPage } from "./pages/LandingPage.js"
import { AuthPage } from "./pages/AuthPage.js"
import { DashboardPage } from "./pages/DashboardPage.js"
import { ServersPage } from "./pages/ServersPage.js"
import { ServerOverviewPage } from "./pages/ServerOverviewPage.js"
import { ServerConsolePage } from "./pages/ServerConsolePage.js"
import { ServerLogsPage } from "./pages/ServerLogsPage.js"
import { ServerBackupsPage } from "./pages/ServerBackupsPage.js"
import { ServerFilesPage } from "./pages/ServerFilesPage.js"
import { ServerModsPage } from "./pages/ServerModsPage.js"
import { ServerConfigPage } from "./pages/ServerConfigPage.js"
import { ServerPlayersPage } from "./pages/ServerPlayersPage.js"
import { ServerSettingsPage } from "./pages/ServerSettingsPage.js"
import { ServerAccessPage } from "./pages/ServerAccessPage.js"
import { ProfilePage } from "./pages/ProfilePage.js"
import { FamiliesPage } from "./pages/FamiliesPage.js"
import { FamilyDetailPage } from "./pages/FamilyDetailPage.js"
import { AuditLogPage } from "./pages/AuditLogPage.js"
import { PlaceholderPage } from "./pages/PlaceholderPage.js"
import { AdminPage } from "./pages/AdminPage.js"
import { NotFoundPage } from "./pages/NotFoundPage.js"

/**
 * Route tree per FRONTEND_REFERENCE.md section 8. Todas las tabs de
 * servidor (FR seccion 16) tienen contenido real. Archivos/Mods/
 * Configuracion/Jugadores (esta sesion, 2026-07-26, a pedido explicito de
 * Joanfer de seguir sin esperar verificacion contra una instancia real de
 * Crafty/Modrinth) reusan el mismo patron request/reply que
 * consola/logs/backups/status ya establecieron. families/profile/audit
 * ya tienen contenido real. /admin (FR seccion 19 item 18) tiene
 * contenido real para lo que ya tiene backend (infra status + runtime_config,
 * ver AdminPage.tsx).
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      {/* /login and /register both render the same unified username-first
          flow (AuthPage decides login vs create-account after checking
          whether the username exists) -- kept as two route aliases so
          existing bookmarks/links to either path keep working. */}
      <Route path="/login" element={<AuthPage />} />
      <Route path="/register" element={<AuthPage />} />

      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/servers" element={<ServersPage />} />

        <Route path="/servers/:serverId" element={<ServerTabsLayout />}>
          <Route index element={<ServerOverviewPage />} />
          <Route path="console" element={<ServerConsolePage />} />
          <Route path="logs" element={<ServerLogsPage />} />
          <Route path="files" element={<ServerFilesPage />} />
          <Route path="mods" element={<ServerModsPage />} />
          <Route path="config" element={<ServerConfigPage />} />
          <Route path="backups" element={<ServerBackupsPage />} />
          <Route path="players" element={<ServerPlayersPage />} />
          <Route path="settings" element={<ServerSettingsPage />} />
          <Route path="access" element={<ServerAccessPage />} />
        </Route>

        <Route path="/families" element={<FamiliesPage />} />
        <Route path="/families/:familyId" element={<FamilyDetailPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/audit" element={<AuditLogPage />} />
        <Route
          path="/admin"
          element={
            <RequireHostOwner>
              <AdminPage />
            </RequireHostOwner>
          }
        />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
